/**
 * @file   src\utils\enums.ts
 * @brief  This file is responsible define enums.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */


// Sort order type enum.
export enum SortOrderType {
  'ASC' = 1,
  'DESC' = 2,
}

export enum BuyType {
  'SINGLE_WASH' = 1,
  'SUBSCRIPTION' = 2
}

// Equipment Type enum
export enum EquipmentType {
  Tunnel = "Tunnel",
  Bay = "Automatic",
  SelfServe = "Self Serve",
  DogWash = "Dog Wash",
  Vacuum = "Vacuum",
}

// export enum EquipmentType {
//   "Tunnel" = "Tunnel",
//   "Bay" = "In Bay",
// }

export enum ServiceType {
  "bayTunnel" = 0,
  "selfServe" = 1,
  "dogWash" = 2,
  "vacuumWash" = 3
}

export const ServiceTypeLabel: Record<ServiceType, string> = {
  [ServiceType.bayTunnel]: "Automatic/Tunnel",
  [ServiceType.selfServe]: "Self Serve",
  [ServiceType.dogWash]: "Dog Wash",
  [ServiceType.vacuumWash]: "Vacuum"
};

  export const bayTypeLabelMap: { [key: number]: EquipmentType } = {
    1: EquipmentType.Tunnel,
    2: EquipmentType.Bay,
    3: EquipmentType.SelfServe,
    4: EquipmentType.DogWash,
    5: EquipmentType.Vacuum,
  };

  export enum EquipmentTypeId {
  "Tunnel" = 1,
  "In Bay" = 2,
  "Self Serve" = 3,
  "Dog Wash" = 4,
  "Vacuum" = 5
  
}
